import { render, staticRenderFns } from "./DocumentTotalDialog.vue?vue&type=template&id=344f4ace&scoped=true&"
import script from "./DocumentTotalDialog.vue?vue&type=script&lang=js&"
export * from "./DocumentTotalDialog.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTotalDialog.vue?vue&type=style&index=0&id=344f4ace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344f4ace",
  null
  
)

export default component.exports